import {
  alertMessagesArgsConfig,
  browserStorageArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  consoleLogArgsConfig,
  getItemIdFromArgsConfig,
  isNonPersistentArgsConfig,
} from '../../utils/event_constants';

export const spinMobileActions = [
  {
    name: 'metropolCreditReport',
    label: 'Metropol Credit Report',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'identifierField', label: 'Select ID Number Field' }),
      collectionFieldArgsConfig({ name: 'loanAmountField', label: 'Select Loan Amount Field' }),
      {
        name: 'reportType',
        label: 'Select Report Type',
        type: 'dropdown',
        optionsType: 'reportType',
        options: [
          { label: 'Summary', value: 'JSON REPORT' },
          { label: 'Full Report', value: 'FULL JSON REPORT' },
        ],
        value: '',
      },
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({
        name: 'metropolCreditReportReferenceField',
        label: 'Metropol Credit Report Reference Field',
      }),
      ...alertMessagesArgsConfig,
      ...isNonPersistentArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'iprsKenya',
    label: 'IPRS - Kenya',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'identifierField', label: 'Select ID Number Field' }),
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({ name: 'iprsReferenceField', label: 'IPRS Reference Field' }),
      ...alertMessagesArgsConfig,
      ...isNonPersistentArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'kraPinChecker',
    label: 'KRA PIN Checker',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'identifierField', label: 'Select KRA PIN Field' }),
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({ name: 'kraReferenceField', label: 'KRA Reference Field' }),
      ...alertMessagesArgsConfig,
      ...isNonPersistentArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'eStatementAnalysis',
    label: 'E-Statement Analysis',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'statementField', label: 'Select Statement Field' }),
      {
        name: 'statementType',
        label: 'Select Statement Type',
        type: 'dropdown',
        optionsType: 'statementType',
        options: [
          { label: 'M Pesa', value: 'MPESA' },
          { label: 'Bank', value: 'BANK' },
          { label: 'Airtel', value: 'AIRTEL' },
        ],
        value: '',
      },
      collectionFieldArgsConfig({ name: 'bankField', label: 'Select Bank Field' }),
      collectionFieldArgsConfig({
        name: 'decrypterField',
        label: 'Select Statement Password Field',
      }),
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({
        name: 'eStatementReferenceField',
        label: 'E-Statement Reference Field',
      }),
      ...alertMessagesArgsConfig,
      ...isNonPersistentArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
];
